export interface ScannerErrorMessages {
  noMediaDevices: string;
  noPermissions: string;
  cameraManuallyDisabled: string;
}
